import React, { useState } from 'react';
import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';
import Image from 'next/image';
import styles from './gallery.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

type Props = {
  simple?: boolean;
  images: {
    id: string;
    url: string;
    title: string;
    width: number;
    height: number;
  }[];
};

const Gallery = ({ images, simple = false }: Props) => {
  const [show, setShow] = useState(false);
  const [initial, setInitial] = useState(0);
  return simple ? (
    <div>
      {images.map((img, i) => (
        <div
          key={i}
          className={styles.simpleImageWrapper}
          style={{ maxWidth: img.height > 500 ? '400px' : '50%' }}
        >
          <Image
            src={`http://localhost:5000${img.url}`}
            alt={img.title}
            loading="eager"
            height={img.height}
            width={img.width}
          />
        </div>
      ))}
    </div>
  ) : (
    <div className={styles.galleryWrapper}>
      {images.map((img, i) => (
        <div
          className={styles.thumbnail}
          key={img.id}
          onClick={() => {
            setInitial(i);
            setShow(true);
          }}
        >
          {!simple ? (
            <a
              href={img.url}
              className={styles.download}
              download
              onClick={(e) => e.stopPropagation()}
            >
              <FontAwesomeIcon icon={faDownload} />
            </a>
          ) : (
            ''
          )}
          <Image
            src={`http://localhost:5000${img.url}`}
            alt={img.title}
            loading="eager"
            height={img.height}
            width={img.width}
            layout="responsive"
          />
          {img.title && <span className={styles.caption}>{img.title}</span>}
        </div>
      ))}
      {show && (
        <Lightbox
          images={images}
          onClose={() => setShow(false)}
          startIndex={initial}
        />
      )}
    </div>
  );
};

export default Gallery;
